module.exports = __webpack_public_path__ + "img/arrow.a198b82d.svg";